import { SUBJECTS } from './studyDashboard';

export const draftRow = (row) => ({
  ...row,
  dirty: false,
  subjects: Object.fromEntries(SUBJECTS.map(([key]) => [key, Number(row.subjects?.[key] || 0)])),
  extraQuestions: Math.max(0, Number(row.questions || 0) -
    SUBJECTS.reduce((sum, [key]) => sum + Number(row.subjects?.[key] || 0), 0)),
  pages: Number(row.pages || 0),
});
